import axios from "axios";
import { endpointApi } from "../../utils";
import { ORDER_LIST_FAIL, ORDER_LIST_REQUEST, ORDER_LIST_SUCCESS, ORDER_LIST_UPDATE } from "../constats/order.constant";
import { logout } from "./auth.action";

export const getOrders = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: ORDER_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }orders${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: ORDER_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: ORDER_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: ORDER_LIST_FAIL,
                payload: err.response && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}

export const changeElementInList = (order) => async(dispatch) => {
    dispatch({
        type: ORDER_LIST_UPDATE,
        payload: order
    })
}